define(() => {
    "use strict";

    /**
     * Defines the states of the <tt>ChannelContent</tt>.
     *
     * @typedef {Object} ChannelContentState
     *
     * @see  ChannelContent
     * @see  Channel#content
     */
    return {
        // Not loaded (including if it cannot be (pre-)loaded because no jQuery available).
        NOT_LOADED: "notloaded",
        // A load is in progress, but has not completed yet.
        PENDING: "pending",
        // From in-memory cache.
        CACHE: "cache",
        // From session/local storage (and thus from the cache as well).
        LOCAL: "local",
        // loaded, and stored in <tt>content</tt>, including if embedded. Note that when groups are
        // store, the experience data may also be loaded (by the viewer), but such content is not
        // stored here, but may be cached.
        LOADED: "loaded",
        // Preload failed.
        FAILED: "failed"
    };
});



// WEBPACK FOOTER //
// ./src/shared/channels/ChannelContentState.js